import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiLiftCabinLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29L13 5.198V9h5.75c1.21 0 2.3.84 2.64 2.04.73 2.58.79 5.31.17 7.92l-.21.88c-.3 1.27-1.4 2.16-2.66 2.16H5.29c-1.27 0-2.36-.89-2.66-2.16l-.21-.88c-.62-2.61-.56-5.34.17-7.92C2.93 9.84 4.02 9 5.23 9H11V5.948l-2.65.992C8.23 6.98 8.12 7 8 7m-.055 4H5.24c-.33 0-.62.24-.72.59-.27.951-.436 1.928-.495 2.91H7.68v-2.21c0-.457.094-.893.265-1.29m-.265 5.5H4.049q.086 1.01.321 2l.21.88c.09.36.38.62.72.62h2.645a3.3 3.3 0 0 1-.265-1.29zm3.29 3.5c-.71 0-1.29-.58-1.29-1.29V16.5h4.63v2.21c0 .71-.58 1.29-1.29 1.29zm5.075 0h2.665c.33 0 .63-.26.72-.62l.21-.88q.236-.99.321-2H16.31v2.21c0 .457-.094.893-.265 1.29m.265-5.5h3.675a13.7 13.7 0 0 0-.495-2.91c-.1-.35-.39-.59-.72-.59h-2.725c.17.397.265.833.265 1.29zM13.02 11h-2.05c-.71 0-1.29.58-1.29 1.29v2.21h4.63v-2.21c0-.71-.58-1.29-1.29-1.29"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiLiftCabinLarge;
